var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunityImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 335,
    height: 200,
    viewBox: "0 0 335 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 -8.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M285.646,574.744H522.172V558.309c0-3.432-3.589-6.811-9.846-9.269l-.064-.025c-4.225-1.718-31.23-13.944-45.838-13.574-7.716.195-14.323,1.7-19.635,4.481-16.536,8.652-38.257,11.848-49.733,9.337-10.114-2.214-37.879-5.874-48.138-5.708-14.368.228-14.41,2.995-29.158,11.924-5.633,3.408-7.74,3.835-34.114,6.554Z",
    transform: "translate(-237.301 -394.141)",
    fill: "#e4302c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M184.96,543.057c-.515-8.817,2.732-17.725,9.462-21a48.265,48.265,0,0,0,4.637,27.931c1.683,3.409,3.845,7.048,3.385,10.61a7.537,7.537,0,0,1-3.192,5.121,18.906,18.906,0,0,1-5.342,2.358l-.321.389C189.167,560.575,185.475,551.875,184.96,543.057Z",
    transform: "translate(-174.748 -386.611)",
    fill: "#e4302c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M202.619,521.985a34.767,34.767,0,0,0-4.2,20.006,18.055,18.055,0,0,0,.925,4.68,10.434,10.434,0,0,0,2.5,3.876,20.487,20.487,0,0,1,2.926,3.163,6.3,6.3,0,0,1,.934,4.28,12.4,12.4,0,0,1-1.86,4.669,12.179,12.179,0,0,0-2.065,5.19c-.02.244-.359.14-.339-.1.29-3.507,2.856-5.64,3.719-8.834a6.141,6.141,0,0,0-.465-4.691,15.991,15.991,0,0,0-2.924-3.267,11.059,11.059,0,0,1-2.559-3.7,16.825,16.825,0,0,1-1.076-4.647,36.989,36.989,0,0,1,.422-10.376,32.729,32.729,0,0,1,3.792-10.519C202.461,521.512,202.731,521.792,202.619,521.985Z",
    transform: "translate(-182.846 -386.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M191.3,555.789a5.952,5.952,0,0,1-4.33-5.265c-.024-.251.314-.251.338,0a5.506,5.506,0,0,0,4.035,4.889.186.186,0,0,1,.141.213.17.17,0,0,1-.185.163Z",
    transform: "translate(-176.025 -402.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M206.648,578.85a8.79,8.79,0,0,0,2.909-6.017c.021-.244.36-.141.339.1a9.133,9.133,0,0,1-3.039,6.253C206.692,579.328,206.484,578.988,206.648,578.85Z",
    transform: "translate(-188.211 -415.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M202.05,537.531a2.194,2.194,0,0,0,2.388-.283c.163-.141.37.2.209.339a2.456,2.456,0,0,1-2.641.32.236.236,0,0,1-.147-.24.173.173,0,0,1,.068-.12A.13.13,0,0,1,202.05,537.531Z",
    transform: "translate(-185.274 -395.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M233.057,554.115c-.1.092-.2.184-.3.279a29.759,29.759,0,0,0-3.641,4.133c-.087.115-.173.232-.256.35a36.359,36.359,0,0,0-5.651,12.638,40.932,40.932,0,0,0-.943,5.753c-.25,2.711-.328,5.7-1.339,7.968a5.891,5.891,0,0,1-.35.684l-12.407.726c-.031-.015-.061-.026-.092-.041l-.491.055c0-.1.008-.209.011-.312,0-.06.006-.12.007-.18,0-.04,0-.08,0-.116,0-.013,0-.027,0-.037,0-.036,0-.07,0-.1q.04-.893.092-1.786s0,0,0-.007a60.319,60.319,0,0,1,2.1-13.183c.036-.125.072-.253.114-.378a34.636,34.636,0,0,1,2.082-5.348,28.322,28.322,0,0,1,1.5-2.671,21.215,21.215,0,0,1,5.155-5.588,16.039,16.039,0,0,1,14.008-2.945C232.8,554.041,232.928,554.076,233.057,554.115Z",
    transform: "translate(-188.832 -404.301)",
    fill: "#e4302c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M233.051,554.856a25.334,25.334,0,0,0-14.374,11.363A13.44,13.44,0,0,0,217,570.2a9.72,9.72,0,0,0,.144,4.5,21.515,21.515,0,0,1,.9,4.287,4.788,4.788,0,0,1-1.456,3.7,9.6,9.6,0,0,1-4.131,2.042,9.441,9.441,0,0,0-4.59,2.272c-.148.16-.392-.149-.244-.309,2.125-2.3,5.528-2.044,7.992-3.725a4.507,4.507,0,0,0,2.089-3.67,16.607,16.607,0,0,0-.841-4.36,10.526,10.526,0,0,1-.285-4.419,12.706,12.706,0,0,1,1.527-4.063,26.157,26.157,0,0,1,5.9-7.113,24.906,24.906,0,0,1,8.955-4.877c.2-.061.292.326.09.387Z",
    transform: "translate(-188.823 -404.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M236.778,568.23a6,6,0,0,1-1.018-6.76c.112-.2.411.039.3.235a5.559,5.559,0,0,0,.958,6.288C237.187,568.177,236.947,568.414,236.778,568.23Z",
    transform: "translate(-205.932 -408.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M231.872,596.181a7.137,7.137,0,0,0,5.776-2.277c.149-.16.393.149.244.309a7.423,7.423,0,0,1-6.017,2.355c-.22-.015-.222-.4,0-.386Z",
    transform: "translate(-203.81 -427.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M257.8,561.578a2.973,2.973,0,0,0,2.26,1.454c.219.012.221.4,0,.386a3.329,3.329,0,0,1-2.5-1.6.219.219,0,0,1,0-.273.162.162,0,0,1,.242.036Z",
    transform: "translate(-219.833 -408.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M975.826,543.057c.515-8.817-2.732-17.725-9.461-21a48.265,48.265,0,0,1-4.637,27.931c-1.683,3.409-3.845,7.048-3.385,10.61a7.537,7.537,0,0,0,3.193,5.121,18.905,18.905,0,0,0,5.342,2.358l.321.389C971.618,560.575,975.31,551.875,975.826,543.057Z",
    transform: "translate(-654.974 -386.611)",
    fill: "#e4302c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M974.193,521.985a34.767,34.767,0,0,1,4.2,20.006,18.059,18.059,0,0,1-.925,4.68,10.432,10.432,0,0,1-2.5,3.876,20.481,20.481,0,0,0-2.926,3.163,6.3,6.3,0,0,0-.934,4.28,12.4,12.4,0,0,0,1.86,4.669,12.18,12.18,0,0,1,2.065,5.19c.02.244.359.14.339-.1-.29-3.507-2.856-5.64-3.719-8.834a6.14,6.14,0,0,1,.465-4.691,15.989,15.989,0,0,1,2.924-3.267,11.058,11.058,0,0,0,2.559-3.7,16.828,16.828,0,0,0,1.076-4.647,36.989,36.989,0,0,0-.422-10.376,32.73,32.73,0,0,0-3.792-10.519C974.351,521.512,974.082,521.792,974.193,521.985Z",
    transform: "translate(-662.904 -386.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M990.918,555.789a5.952,5.952,0,0,0,4.33-5.265c.024-.251-.314-.251-.338,0a5.507,5.507,0,0,1-4.035,4.889.186.186,0,0,0-.141.213A.17.17,0,0,0,990.918,555.789Z",
    transform: "translate(-675.125 -402.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M977.544,578.85a8.789,8.789,0,0,1-2.909-6.017c-.021-.244-.36-.141-.339.1a9.133,9.133,0,0,0,3.039,6.253C977.5,579.328,977.708,578.988,977.544,578.85Z",
    transform: "translate(-664.919 -415.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M982.9,537.531a2.194,2.194,0,0,1-2.388-.283c-.163-.141-.37.2-.209.339a2.456,2.456,0,0,0,2.641.32.236.236,0,0,0,.147-.24.173.173,0,0,0-.068-.119.13.13,0,0,0-.123-.017Z",
    transform: "translate(-668.613 -395.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M914.834,554.115c.1.092.2.184.3.279a29.752,29.752,0,0,1,3.641,4.133c.087.115.173.232.256.35a36.361,36.361,0,0,1,5.651,12.638,40.939,40.939,0,0,1,.943,5.753c.25,2.711.328,5.7,1.339,7.968a5.892,5.892,0,0,0,.35.684l12.407.726c.031-.015.062-.026.093-.041l.491.055c0-.1-.008-.209-.011-.312,0-.06-.006-.12-.007-.18,0-.04,0-.08,0-.116,0-.013,0-.027,0-.037,0-.036,0-.07,0-.1q-.04-.893-.092-1.786s0,0,0-.007a60.321,60.321,0,0,0-2.1-13.183c-.037-.125-.072-.253-.114-.378a34.647,34.647,0,0,0-2.082-5.348,28.334,28.334,0,0,0-1.5-2.671,21.217,21.217,0,0,0-5.155-5.588,16.039,16.039,0,0,0-14.008-2.945C915.089,554.041,914.963,554.076,914.834,554.115Z",
    transform: "translate(-627.997 -404.301)",
    fill: "#e4302c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M914.64,554.856a25.333,25.333,0,0,1,14.374,11.363,13.441,13.441,0,0,1,1.677,3.982,9.72,9.72,0,0,1-.144,4.5,21.519,21.519,0,0,0-.9,4.286,4.788,4.788,0,0,0,1.456,3.7,9.6,9.6,0,0,0,4.131,2.042,9.441,9.441,0,0,1,4.59,2.272c.148.16.392-.149.244-.309-2.125-2.3-5.528-2.044-7.992-3.725a4.507,4.507,0,0,1-2.089-3.67,16.61,16.61,0,0,1,.841-4.36,10.526,10.526,0,0,0,.285-4.419,12.705,12.705,0,0,0-1.527-4.063,26.153,26.153,0,0,0-5.9-7.113,24.9,24.9,0,0,0-8.955-4.877c-.2-.061-.292.326-.09.386Z",
    transform: "translate(-627.805 -404.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M949.645,568.23a6,6,0,0,0,1.018-6.76c-.112-.2-.411.039-.3.235a5.559,5.559,0,0,1-.958,6.288C949.236,568.177,949.476,568.414,949.645,568.23Z",
    transform: "translate(-649.428 -408.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M947.537,596.181a7.136,7.136,0,0,1-5.776-2.277c-.149-.16-.393.149-.244.309a7.423,7.423,0,0,0,6.017,2.355C947.753,596.552,947.755,596.166,947.537,596.181Z",
    transform: "translate(-644.536 -427.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M927.363,561.578a2.974,2.974,0,0,1-2.26,1.455c-.219.012-.221.4,0,.386a3.329,3.329,0,0,0,2.5-1.6.219.219,0,0,0,0-.273A.162.162,0,0,0,927.363,561.578Z",
    transform: "translate(-634.27 -408.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 2.274,
    height: 0.874,
    transform: "translate(18.938 112.794)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M507.863,471.083h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H484.78v-.874H489.4Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.616Zm-9.233,0H457.08v-.874H461.7Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H429.38v-.874H434Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H401.68v-.874H406.3Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0H373.98v-.874H378.6Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H346.28v-.874H350.9Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H318.58v-.874H323.2Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H290.88v-.874H295.5Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H263.18v-.874H267.8Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H235.48v-.874H240.1Zm-9.233,0h-4.617v-.874h4.617Z",
    transform: "translate(-200.418 -357.415)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 2.274,
    height: 0.874,
    transform: "translate(312.062 112.794)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 2.274,
    height: 0.874,
    transform: "translate(18.938 106.678)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M507.863,457.083h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H484.78v-.874H489.4Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.616Zm-9.233,0H457.08v-.874H461.7Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H429.38v-.874H434Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H401.68v-.874H406.3Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0H373.98v-.874H378.6Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H346.28v-.874H350.9Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H318.58v-.874H323.2Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H290.88v-.874H295.5Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H263.18v-.874H267.8Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H235.48v-.874H240.1Zm-9.233,0h-4.617v-.874h4.617Z",
    transform: "translate(-200.418 -349.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 2.274,
    height: 0.874,
    transform: "translate(312.062 106.678)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 2.274,
    height: 0.874,
    transform: "translate(18.938 94.007)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M507.863,428.083h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H484.78v-.874H489.4Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.616Zm-9.233,0H457.08v-.874H461.7Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H429.38v-.874H434Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H401.68v-.874H406.3Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0H373.98v-.874H378.6Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H346.28v-.874H350.9Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H318.58v-.874H323.2Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H290.88v-.874H295.5Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H263.18v-.874H267.8Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H235.48v-.874H240.1Zm-9.233,0h-4.617v-.874h4.617Z",
    transform: "translate(-200.418 -333.202)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 2.274,
    height: 0.874,
    transform: "translate(312.062 94.007)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 2.274,
    height: 0.874,
    transform: "translate(18.938 85.269)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M507.863,408.083h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H484.78v-.874H489.4Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.616Zm-9.233,0H457.08v-.874H461.7Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H429.38v-.874H434Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H401.68v-.874H406.3Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0H373.98v-.874H378.6Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H346.28v-.874H350.9Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H318.58v-.874H323.2Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H290.88v-.874H295.5Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H263.18v-.874H267.8Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H235.48v-.874H240.1Zm-9.233,0h-4.617v-.874h4.617Z",
    transform: "translate(-200.418 -321.94)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 2.274,
    height: 0.874,
    transform: "translate(312.062 85.269)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 2.274,
    height: 0.874,
    transform: "translate(18.938 66.482)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M507.863,365.083h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H484.78v-.874H489.4Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.616Zm-9.233,0H457.08v-.874H461.7Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H429.38v-.874H434Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H401.68v-.874H406.3Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.616v-.874h4.616Zm-9.233,0H373.98v-.874H378.6Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H346.28v-.874H350.9Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H318.58v-.874H323.2Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H290.88v-.874H295.5Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H263.18v-.874H267.8Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0h-4.617v-.874h4.617Zm-9.233,0H235.48v-.874H240.1Zm-9.233,0h-4.617v-.874h4.617Z",
    transform: "translate(-200.418 -297.727)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 2.274,
    height: 0.874,
    transform: "translate(312.062 66.482)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M430.99,272.081c0,11.1-9.238,20.093-20.633,20.093s-20.633-9-20.633-20.093,9.238-20.093,20.633-20.093a20.828,20.828,0,0,1,14.617,5.859,19.74,19.74,0,0,1,6.016,14.234Z",
    transform: "translate(-301.928 -222.276)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M434.709,279.4h0l-.1.212a8.394,8.394,0,0,0-1.539-7.709,9.647,9.647,0,0,0-6.094-3.189,8.656,8.656,0,0,0-4.923.441c-2.268,1.007-4,3.339-5.448,5.764a6.871,6.871,0,0,0-1.247,3.761,8.861,8.861,0,0,0,1.266,3.47,5.019,5.019,0,0,1,.606,3.638,7.218,7.218,0,0,1-1.121,1.8,2.674,2.674,0,0,0-.533,2.095,1.569,1.569,0,0,0,1.1,1.107,3.4,3.4,0,0,0,1.468-.04l12.648-2.2a5.519,5.519,0,0,0,4.03-3.4,7.06,7.06,0,0,0-.117-5.752Z",
    transform: "translate(-317.843 -243.859)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 6.184,
    cy: 7.128,
    rx: 6.184,
    ry: 7.128,
    transform: "translate(101.275 30.335)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M437.742,329.415c-7.438,9.755-20.29,10.825-28.867,2.4l1.77-5.692a5.381,5.381,0,0,1,4.511-3.57l1.126-.08,2.685-2.669s7.234-.3,7.126-.44l4.382,3.038,0-.021,1.722.122a5.379,5.379,0,0,1,4.511,3.57Z",
    transform: "translate(-313.82 -272.478)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M433.82,279.761a2.2,2.2,0,0,0-1.759-1.634,14.766,14.766,0,0,0-6.555-.415,6.775,6.775,0,0,0-4.384,2.275,7.4,7.4,0,0,0-1.491,4.377,5.875,5.875,0,0,0,.541,2.781,2.24,2.24,0,0,0,1.859,1.381l.074.3a11.334,11.334,0,0,0,7.805-6.026,7.977,7.977,0,0,1-1.957,3.644,12.587,12.587,0,0,0,5.263-4.676A2.9,2.9,0,0,0,433.82,279.761Z",
    transform: "translate(-320.496 -248.914)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 20.633,
    cy: 20.093,
    rx: 20.633,
    ry: 20.093,
    transform: "translate(263.627 36.081)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.913,
    cy: 3.358,
    rx: 2.913,
    ry: 3.358,
    transform: "translate(275.681 33.133)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.38,
    cy: 8.506,
    rx: 7.38,
    ry: 8.506,
    transform: "translate(275.875 35.596)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 5.997,
    cy: 6.912,
    rx: 5.997,
    ry: 6.912,
    transform: "translate(277.869 38.781)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M900.627,299.01a6.1,6.1,0,0,0-7-.106,8.224,8.224,0,0,0-3.448,7.017c3.056.884,6.266,1.561,9.525.211l.77-2.171.454,2.173c.992.468,1.987.863,2.982,0A8.47,8.47,0,0,0,900.627,299.01Z",
    transform: "translate(-612.689 -260.363)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M871.043,273.992a5.35,5.35,0,0,0-6.219,1.1,8.472,8.472,0,0,0-2.151,6.913c.33,2.578,1.69,4.8,2.943,6.966s2.478,4.545,2.476,7.151c0,3.908-2.747,7.076-6.138,7.084,1.911.948,3.906,1.915,5.984,1.8a4.9,4.9,0,0,0,4.6-4.019c.244-1.7-.481-3.367-1.087-4.948a39.049,39.049,0,0,1-2.122-8.053,9.3,9.3,0,0,1,.04-3.987,4.1,4.1,0,0,1,4.035-3.073l.687-.712A6.382,6.382,0,0,0,871.043,273.992Z",
    transform: "translate(-595.161 -246.617)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M901.7,347.149c-7.438,9.755-20.29,10.825-28.867,2.4l1.77-5.692a5.381,5.381,0,0,1,4.511-3.57l1.126-.08,2.685-2.669s7.234-.3,7.126-.44l4.382,3.038,0-.021,1.722.122a5.379,5.379,0,0,1,4.511,3.57Z",
    transform: "translate(-601.917 -282.464)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M739.99,231.355c-.02,11.1-9.274,20.077-20.67,20.057s-20.617-9.032-20.6-20.129,9.274-20.077,20.67-20.057a20.863,20.863,0,0,1,14.595,5.9A19.775,19.775,0,0,1,739.99,231.355Z",
    transform: "translate(-493.802 -196.561)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M727.34,238.415c.853-3.134,2.793-6.009,5.477-7.068s6.612.554,8.63,2.872c3.69,4.239,4.59,18.8,2.055,23.4-.5-.031-2.244-.054-2.755-.076l-.722-2.774v2.746q-1.22-.043-2.458-.06c-5.754-.082-10.421-5.4-10.563-12.028A32.522,32.522,0,0,1,727.34,238.415Z",
    transform: "translate(-511.349 -222.727)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 5.88,
    cy: 6.778,
    rx: 5.88,
    ry: 6.778,
    transform: "translate(219.368 12.52)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M738.962,237.553l6.771-3.908h0a9.856,9.856,0,0,1,4.984,8.127l.169,2.33-2.835-.832-.311-2.979-.482,2.747-1.308-.384.012-4.626-1.309,4.622-4.673-1.238Z",
    transform: "translate(-518.789 -224.208)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M746.262,288.735c-7.438,9.755-20.29,10.825-28.867,2.4l1.77-5.692a5.381,5.381,0,0,1,4.511-3.57l1.126-.08,2.685-2.669s7.234-.3,7.126-.44l4.382,3.038,0-.021,1.722.122a5.379,5.379,0,0,1,4.511,3.57Z",
    transform: "translate(-505.397 -249.571)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 20.633,
    cy: 20.093,
    rx: 20.633,
    ry: 20.093,
    transform: "translate(148.198 47.154)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 6.586,
    cy: 7.592,
    rx: 6.586,
    ry: 7.592,
    transform: "translate(161.676 49.643)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M597.061,377.149c-7.438,9.755-20.29,10.825-28.867,2.4l1.77-5.692a5.381,5.381,0,0,1,4.511-3.57l1.126-.08,2.685-2.669s7.234-.3,7.126-.44l4.382,3.038,0-.021,1.722.122a5.379,5.379,0,0,1,4.511,3.57Z",
    transform: "translate(-412.75 -299.356)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M597.788,323.511a9.81,9.81,0,0,0-3.556-5.577,5.167,5.167,0,0,0-4.675-1,4.35,4.35,0,0,0-2.761,4.226,1.482,1.482,0,0,0-1.622.577,4.574,4.574,0,0,0-.8,1.857,13.545,13.545,0,0,0,.1,6.539l-.031.305a2.714,2.714,0,0,0,1.7-1.707c.36-.805.568-1.7.959-2.484a2.386,2.386,0,0,1,1.814-1.511l-.068,1.364,2-1.186-.475,1.31,1.745-.84-.2,1.26a2.748,2.748,0,0,1,1.54-1.547,2.291,2.291,0,0,1,2.034.216,4.009,4.009,0,0,1,1.41,2.286,13.784,13.784,0,0,1,.338,2.854,11.38,11.38,0,0,0,.543-6.94Z",
    transform: "translate(-422.58 -270.985)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 20.633,
    cy: 20.093,
    rx: 20.633,
    ry: 20.093,
    transform: "translate(28.745 56.289)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ab6171fa-7d69-4734-b81c-8dff60f9761b",
    cx: 6.26,
    cy: 7.215,
    rx: 6.26,
    ry: 7.215,
    transform: "translate(42.665 60.728)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M281.221,401.415c-7.438,9.755-20.29,10.825-28.867,2.4l1.77-5.692a5.381,5.381,0,0,1,4.511-3.57l1.126-.08,2.685-2.669s7.234-.3,7.126-.44l4.382,3.038,0-.021,1.722.122a5.379,5.379,0,0,1,4.511,3.57Z",
    transform: "translate(-216.629 -313.02)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M271.992,375.037c-.012-.04-.023-.079-.036-.119-.024.025-.047.05-.073.073Z",
    transform: "translate(-228.756 -303.757)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M283.409,351.737a5.483,5.483,0,0,0-1.68-3.786,4.211,4.211,0,0,1-1.028-1.072,8.013,8.013,0,0,1-.349-1,2.841,2.841,0,0,0-3.078-1.819,4.654,4.654,0,0,0-3.008,2.32,1.833,1.833,0,0,0-2.191.311,2.582,2.582,0,0,0-.672,2.424c-.636-.591-1.665-.118-2.062.7a4.994,4.994,0,0,0-.216,2.761,29.407,29.407,0,0,0,1.064,4.944,3.607,3.607,0,0,0,.506-2.742c-.079-1.006-.032-2.233.731-2.729.737-.479,1.632.047,2.444.319a4.112,4.112,0,0,0,3.821-.693,12.164,12.164,0,0,1,1.257-1.009,1.314,1.314,0,0,1,1.462-.03,2.459,2.459,0,0,1,.678,1.373l.939,3.669A5.619,5.619,0,0,0,283.409,351.737Z",
    transform: "translate(-226.986 -286.36)",
    fill: "#232327"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 1.97,
    height: 66.542,
    transform: "translate(47.478 114.779)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 1.97,
    height: 97.62,
    transform: "translate(106.444 83.701)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 1.97,
    height: 77.188,
    transform: "translate(165.531 104.133)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 1.97,
    height: 114.647,
    transform: "translate(224.619 66.674)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 1.97,
    height: 88.54,
    transform: "translate(283.706 92.782)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(101.525 78.321)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(219.7 60.159)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(160.612 97.618)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(42.437 107.834)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(278.787 85.132)",
    fill: "#e4302c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M493.69,625.484H173.812l-2.008,1.157a1.089,1.089,0,0,0,1,1.157H493.689a1.169,1.169,0,0,0,0-2.315Z",
    transform: "translate(-166.611 -444.848)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(0 174.3)",
    fill: "#666d74"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 6.025,
    cy: 6.032,
    rx: 6.025,
    ry: 6.032,
    transform: "translate(42.453 196.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 6.025,
    cy: 6.032,
    rx: 6.025,
    ry: 6.032,
    transform: "translate(101.585 196.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 6.025,
    cy: 6.032,
    rx: 6.025,
    ry: 6.032,
    transform: "translate(160.717 196.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 6.025,
    cy: 6.032,
    rx: 6.025,
    ry: 6.032,
    transform: "translate(219.469 196.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 6.025,
    cy: 6.032,
    rx: 6.025,
    ry: 6.032,
    transform: "translate(278.601 196.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 6.025,
    cy: 6.945,
    rx: 6.025,
    ry: 6.945,
    transform: "translate(322.949 174.3)",
    fill: "#666d74"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityImg);
export default __webpack_public_path__ + "static/media/communityImg.7658d42e8b1a44ec44adbe84c6d5c221.svg";
export { ForwardRef as ReactComponent };